export default __webpack_public_path__ + "static/media/b17-med.32008f13.jpg";